import { useMemo } from "react";
import { useCustomersQuery } from "~/apis/use-customers-query";
import { useWorkflowsQuery } from "~/apis/use-workflows-query";
import type { WorkflowData } from "../../workflows-page";

type Props = {
  workflows: WorkflowData[] | undefined;
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
};

export const useWorkflowsData = (showCompleted: boolean): Props => {
  const workflowsQuery = useWorkflowsQuery(showCompleted);
  const customersQuery = useCustomersQuery();

  const workflows = workflowsQuery.data;
  const customers = customersQuery.data;

  const workflowsWithCustomerNames = useMemo(() => {
    if (!workflows) return undefined;
    const customerById = new Map(customers?.map((customer) => [customer.id, customer]) ?? []);

    return workflows.map((workflow) => {
      const customer = customerById.get(workflow.customerId);

      return {
        ...workflow,
        customerName: customer?.name ?? "Loading...",
      } satisfies WorkflowData;
    });
  }, [workflows, customers]);

  return {
    workflows: workflowsWithCustomerNames,
    isLoading: workflowsQuery.isLoading || customersQuery.isLoading,
    isError: workflowsQuery.isError || customersQuery.isError,
    refetch: () => {
      workflowsQuery.refetch();
      customersQuery.refetch();
    },
  };
};
